import React, { useEffect, useState } from "react";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import { activeList } from "../../../config";
import { AdminService } from "../../../app/service/admin.service";
import { toast } from "react-toastify";
import Select from "react-select";

const EditAlert = () => {
  const [formData, setFormData] = useState<any>({
    batchName: "",
    status: "",
    content: "",
  });
  const [errors, setErrors] = useState<any>({});
  const [batchData, setBatchData] = useState<any>([]);
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const handleInput = (e: any, index?: number) => {
    const { name, value } = e.target;

    setFormData((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));

    setErrors((prevErrors: any) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validate = () => {
    const newErrors: any = {};

    if (!formData.batchName) {
      newErrors.batchName = "Batch Name is required";
    }

    if (!formData.status) {
      newErrors.status = "Status is required";
    }

    if (!formData.content) {
      newErrors.content = "Content is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    getMeets();
  }, []);

  useEffect(() => {
    if (state) {
      setFormData({
        batchName: state.batchName || "",
        status: state.status || "",
        content: state.content || "",
      });
    }
  }, [state]);

  const getMeets = () => {
    const data = {
      search: "",
      start: 1,
      count: 10,
    };
    AdminService.getAllBatch(data).then((res: any) => {
      if (res.status === "Success") {
        setBatchData(res.data);
      } else {
        toast.error(res.message);
      }
    });
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (!validate()) return;

    const payload = {
      batchName: formData.batchName,
      status: formData.status,
      batchId: state._id,
      content: formData.content,
    };

    AdminService.editAlert(payload).then((res: any) => {
      if (res.status === "Fail") {
        toast.error(res.message);
      } else {
        toast.success(res.message);
        navigate("/support/alert");
      }
    });
  };
  const handleSelectChange = (selectedOption: any, { name }: any) => {
    setFormData({ ...formData, [name]: selectedOption.value });
    setErrors((prevErrors: any) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleCancel = () => {
    navigate("/support/alert");
  };
  const bOptions = batchData?.map((type: any) => ({
    value: type.batchName,
    label: type.batchName,
  }));

  return (
    <div className="container-fluid">
      <div className="row">
        <Header />
      </div>
      <div className="row">
        <div className="col-md-2 h-100 px-0">
          <Sidebar />
        </div>
        <div className="col-md-10 content-scroll content-bg px-3 py-3">
          <h4 style={{ textAlign: "left" }}>
            <b>Edit Alert</b>
          </h4>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group mt-3">
                  <label className="register-font">Batch Name*</label>
                  <Select
                    options={bOptions}
                    name="batchName"
                    placeholder="Select Batch"
                    onChange={handleSelectChange}
                    value={bOptions.find(
                      (option: any) => option.value === formData.batchName
                    )}
                  />
                  {errors.batchName && (
                    <div className="text-danger">{errors.batchName}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group mt-3">
                  <label className="register-font">Content *</label>
                  <input
                    type="text"
                    className={`form-control mt-2 ${
                      errors.content ? "is-invalid" : ""
                    }`}
                    placeholder="Add Content"
                    name="content"
                    onChange={handleInput}
                  />
                  {errors.content && (
                    <div className="invalid-feedback">{errors.content}</div>
                  )}
                </div>
              </div>
              <div className="form-group mt-3">
                <label className="register-font">Select Status *</label>
                <select
                  className={`form-control mt-2 ${
                    errors.status ? "is-invalid" : ""
                  }`}
                  onChange={handleInput}
                  name="status"
                  value={formData.status}
                >
                  <option>Select Status</option>
                  {activeList.map((ele: any, index) => (
                    <option value={ele.name} key={index}>
                      {ele.name}
                    </option>
                  ))}
                </select>
                {errors.status && (
                  <div className="invalid-feedback">{errors.status}</div>
                )}
              </div>
            </div>

            <div className="mt-3">
              <button type="submit" className="btn btn-primary me-2">
                Update
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditAlert;
